export default __webpack_public_path__ + "static/media/d20-clipart-crit-3-original.1675abfc.png";